import { useState } from 'react'
import { useReadMonitorCurrentlaunchStatusQuery } from '../../services/monitor'

interface useReadMonitorCurrentlaunchStatusParams {
    spyId: number
}

interface useReadMonitorCurrentlaunchStatusOptions {
    skip: boolean,
    pollingInterval: number
}

export function useReadMonitorCurrentlaunchStatus(
    params?: useReadMonitorCurrentlaunchStatusParams,
    options?: useReadMonitorCurrentlaunchStatusOptions
){
    const {
        spyId = undefined
    } = params || {

    }

    const {
        skip = true,
        pollingInterval = 1200,
    } = options || {}

    const [readMonitorCurrentlaunchStatusQueryParams, setReadMonitorCurrentlaunchStatusQueryParams] = useState<any>({
        monitorId: spyId
    })
    const [readMonitorCurrentlaunchStatusQueryOptions, setReadMonitorCurrentlaunchStatusQueryOptions] = useState<any>(
        {
            skip: skip,
            refetchOnMountOrArgChange: true,
            pollingInterval: pollingInterval,
        }
    )

    const {
        data: readMonitorCurrentlaunchStatusQueryData,
        isLoading: readMonitorCurrentlaunchStatusQueryIsLoading,
        isFetching: readMonitorCurrentlaunchStatusQueryIsFetching
    } = useReadMonitorCurrentlaunchStatusQuery(readMonitorCurrentlaunchStatusQueryParams, readMonitorCurrentlaunchStatusQueryOptions)

    return {
        data: readMonitorCurrentlaunchStatusQueryData,
        isLoading: readMonitorCurrentlaunchStatusQueryIsLoading,
        isFetching: readMonitorCurrentlaunchStatusQueryIsFetching,
        setParams: setReadMonitorCurrentlaunchStatusQueryParams,
        setOptions: setReadMonitorCurrentlaunchStatusQueryOptions
    }
}